import { Flex } from 'antd';
import type { FC } from 'react';

import { Select } from '@shared/ui/antd';

import type { TopicOption } from '../lib/dialog-summary-utils';
import styles from '../dialog-summary.module.scss';

type DialogSummaryFiltersProps = {
  placeholder: string;
  selectedTopics: string[];
  topicOptions: TopicOption[];
  onTopicChange: (value: unknown) => void;
};

export const DialogSummaryFilters: FC<DialogSummaryFiltersProps> = ({
  placeholder,
  selectedTopics,
  topicOptions,
  onTopicChange,
}) => (
  <Flex align="center" justify="space-between" className={styles.filters}>
    <Select
      className={styles.topicsSelect}
      selectMode="multiple"
      showSearch={false}
      placeholder={placeholder}
      value={selectedTopics}
      onChange={onTopicChange}
      options={topicOptions}
    />
  </Flex>
);

